export default function sortByDate<T extends { created_at: string }>(
  arr: T[],
  order: 'asc' | 'desc' = 'desc',
  field: keyof T = 'created_at' as keyof T,
): T[] {
  const factor = order === 'desc' ? -1 : 1;

  return [...arr].sort((a, b) => {
    const dateA = new Date(String(a[field])).getTime();
    const dateB = new Date(String(b[field])).getTime();
    return (dateA - dateB) * factor;
  });
}
